import React from 'react';

import { Box } from '@chakra-ui/react';

import Caption from 'uiToolkitV1/Caption';
import Label from 'uiToolkitV1/Label';

export const InputLabel = ({
  children,
  labelText,
  labelIcon,
  containerProps,
  captionText = '',
  captionVariant = 'default',
}) => (
  <Box px={3} py={1.5} {...containerProps}>
    <Label Icon={labelIcon} mb={1}>
      {labelText}
    </Label>
    {children}
    {captionText.length > 0 ? <Caption variant={captionVariant}>{captionText}</Caption> : null}
  </Box>
);
